module.exports = __webpack_public_path__ + "static/media/miira.a13fcd94.png";